import React from 'react';
import { Label } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import { formatDate, formatDateTime } from '../../../shared/utils/date';
import { ABNORMALITIES, I18N, MANIFEST_BASED } from '../../../constants';
import SmallLoader from '../../SmallLoader/index';

const abnormalityNameFormatter = (cell, row) => {
    if (row.genericAbnormalityType && row.genericAbnormalityType === MANIFEST_BASED) {
        return (
            <Link
                to={`manifests/${row.manifestId}/abnormality/${row.abnormalityType}/${
                    row.dashboardId
                }`}
            >
                {row.abnormalityName}
            </Link>
        );
    }
    return (
        <Link to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${row.dashboardId}`}>
            {row.abnormalityName}
        </Link>
    );
};

const abnormalityTypeFormatter = (cell, row) => {
    return <div className={row.abnormalityType === ABNORMALITIES.BLOWOUT ? "blowoutBackground" :
                           row.abnormalityType === ABNORMALITIES.SHORT_SHIPMENT ? "shortShipmentBackground" :
                           row.abnormalityType === ABNORMALITIES.UNABLE_TO_LOCATE ? "unableToLocateBackground" :
                           row.abnormalityType === ABNORMALITIES.MISCOLLECTION ? "miscollectionBackground" :
                           row.abnormalityType === ABNORMALITIES.DAMAGE ? "damageBackground" :
                           row.abnormalityType === ABNORMALITIES.EARLY_FREIGHT ? "earlyFreightBackground" :
                           row.abnormalityType === ABNORMALITIES.LATE_FREIGHT ? "lateFreightBackground" :
                           row.abnormalityType === ABNORMALITIES.NEW_ORDER ? "newOrderBackground" :
                           row.abnormalityType === ABNORMALITIES.PARTIAL_SHORT_SHIPMENT ? "partialShortShipmentBackground" : ""}>
                            {I18N.ABNORMALITIES[row.abnormalityType]}
    </div>

};

class TodoTable extends React.Component {
    render() {
        const { data, isFetching } = this.props;

        const options = {
            defaultSortName: 'abnormalityDate',
            defaultSortOrder: 'desc',
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
        };

        return (
            <div>
                <BootstrapTable
                    data={data}
                    options={options}
                    pagination
                    striped
                    hover
                    maxHeight={500}
                >
                    <TableHeaderColumn isKey hidden dataField="dashboardId">
                        ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="tlmsUpdate"
                        dataFormat={value =>
                            value ? <Label bsStyle="warning">VALIDATE</Label> : ''
                        }
                        dataSort
                        tdStyle={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        TLMS Upd.
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="abnormalityName"
                        dataFormat={abnormalityNameFormatter}
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Abn. Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="abnormalityDate"
                        dataFormat={formatDateTime}
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Abn. Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="abnormalityType"
                        // dataFormat={type => I18N.ABNORMALITIES[type]}
                        dataFormat={abnormalityTypeFormatter}
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Abn. Type
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="routeCode"
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Route
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="runDate"
                        width="110"
                        //dataFormat={formatDate}//-for to do abnormalities
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Run Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="destination"
                        dataFormat={d => <span title={d}>{d}</span>}
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Destination
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="location"
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Abn. Location
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="assigneeGroup"
                        dataFormat={ag => <span title={ag}>{ag}</span>}
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Assignee Group
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="assignee"
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Assignee
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="abnormalityStatus"
                        dataFormat={status => I18N.ABNORMALITY_STATUS[status]}
                        dataSort
                        thStyle={{ whiteSpace: 'normal' }}
                    >
                        Status
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default TodoTable;
